import { render, staticRenderFns } from "./Panier_Inscription_Liste.vue?vue&type=template&id=2a824dd2&scoped=true&"
import script from "./Panier_Inscription_Liste.vue?vue&type=script&lang=js&"
export * from "./Panier_Inscription_Liste.vue?vue&type=script&lang=js&"
import style0 from "./Panier_Inscription_Liste.vue?vue&type=style&index=0&id=2a824dd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a824dd2",
  null
  
)

export default component.exports